import { Link } from "react-router-dom";
import { Heart, HandHeart, ArrowRight } from "lucide-react";

export default function CTASection() {
  return (
    <section className="section-y" data-testid="home-cta">
      <div className="container-sf">
        <div className="grid md:grid-cols-2 gap-6">
          {/* Donation card */}
          <div className="relative rounded-3xl bg-[var(--brand-orange)] text-white p-10 md:p-12 overflow-hidden group" data-testid="cta-donation">
            <div className="grain-overlay" />
            <div className="absolute -bottom-16 -right-16 h-64 w-64 rounded-full bg-white/10" />
            <div className="absolute -top-8 right-16 h-24 w-24 rounded-full bg-white/10" />
            <div className="relative">
              <Heart className="h-10 w-10 mb-6" />
              <h3 className="text-3xl md:text-4xl font-bold leading-tight max-w-md">
                Donasi Anda menjadi harapan bagi banyak orang.
              </h3>
              <p className="mt-4 text-white/85 leading-relaxed max-w-md">
                Setiap rupiah yang Anda berikan diinvestasikan langsung ke program kemanusiaan, pendidikan, kesehatan, dan lingkungan.
              </p>
              <Link
                to="/donasi"
                className="inline-flex mt-8 items-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm md:text-base font-semibold text-[var(--brand-orange)] transition group-hover:-translate-y-1 shadow-lg"
              >
                Berdonasi Sekarang <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </div>

          {/* Volunteer card */}
          <div className="relative rounded-3xl bg-[var(--brand-blue)] text-white p-10 md:p-12 overflow-hidden group" data-testid="cta-volunteer">
            <div className="grain-overlay" />
            <div className="absolute -bottom-16 -left-16 h-64 w-64 rounded-full bg-white/10" />
            <div className="absolute -top-8 left-16 h-24 w-24 rounded-full bg-white/10" />
            <div className="relative">
              <HandHeart className="h-10 w-10 mb-6" />
              <h3 className="text-3xl md:text-4xl font-bold leading-tight max-w-md">
                Bergabunglah dengan gerakan Silih Asih.
              </h3>
              <p className="mt-4 text-white/85 leading-relaxed max-w-md">
                Menjadi relawan bukan hanya memberi waktu — Anda ikut membangun ekosistem dampak yang menyentuh generasi.
              </p>
              <Link
                to="/volunteer"
                className="inline-flex mt-8 items-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm md:text-base font-semibold text-[var(--brand-blue)] transition group-hover:-translate-y-1 shadow-lg"
              >
                Daftar sebagai Relawan <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
